/** 연간시간표 '1·2학기 위치 바꾸기' 설정(워크스페이스별) — localStorage 유지 */

export const ANNUAL_SWAP_TERM_ORDER_CHANGED_EVENT = 'cp:annual-swap-term-order-changed';

function key(workspaceId: string): string {
  return `cp.annualSwapTermOrder.v1.${workspaceId}`;
}

export function loadAnnualSwapTermOrder(workspaceId: string): boolean {
  if (!workspaceId) return false;
  try {
    return window.localStorage.getItem(key(workspaceId)) === '1';
  } catch {
    return false;
  }
}

export function saveAnnualSwapTermOrder(workspaceId: string, value: boolean): void {
  if (!workspaceId) return;
  try {
    window.localStorage.setItem(key(workspaceId), value ? '1' : '0');
  } catch {
    /* ignore quota */
  }
  try {
    window.dispatchEvent(
      new CustomEvent(ANNUAL_SWAP_TERM_ORDER_CHANGED_EVENT, {
        detail: { workspaceId, value },
      })
    );
  } catch {
    /* ignore */
  }
}

export function orderedAcademicTerms(swapTermOrder: boolean): readonly [1, 2] | readonly [2, 1] {
  return swapTermOrder ? [2, 1] : [1, 2];
}
